import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_process_components_iterator_v2 = _resolveComponent("process-components-iterator-v2")!

  return (_openBlock(), _createElementBlock("div", _normalizeProps(_guardReactiveProps(_ctx.attributes)), [
    _createVNode(_component_process_components_iterator_v2, {
      components: _ctx.components,
      layout: _ctx.attributes.layout,
      "view-mode": _ctx.componentViewMode,
      path: _ctx.path,
      "context-path": _ctx.contextPath
    }, null, 8, ["components", "layout", "view-mode", "path", "context-path"])
  ], 16))
}